import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MSG } from "../data/content";

export const FloatingWhatsApp = () => (
  <a
    data-testid="floating-whatsapp-cta"
    href={waLink(DEFAULT_WA_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Solicitar orçamento pelo WhatsApp"
    className="fixed bottom-5 right-5 z-50 group"
  >
    <span className="absolute -top-1 -right-1 flex h-4 w-4">
      <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-75 animate-pulse-dot" />
      <span className="relative inline-flex rounded-full h-4 w-4 bg-gold border-2 border-ink" />
    </span>
    <span className="flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 group-hover:scale-110 group-active:scale-95">
      <MessageCircle className="h-7 w-7 sm:h-8 sm:w-8" />
    </span>
  </a>
);
